import { isExternalLinkFunction } from '@cigna/cigna_csg_gsg_cipublic-link/lib/interfaces.js';

// is base implementation enough? Just an example of how to override
export const isExternalLink: isExternalLinkFunction = (url: URL) => url.protocol.startsWith('http') && url.origin !== location.origin; // && !url.hostname.includes('cigna.com');
